import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const Container = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding: ${theme.spacing.medium};
  background-color: ${theme.colors.background};
`;

const Title = styled.h1`
  color: ${theme.colors.titleText};
  text-align: center;
  margin-bottom: ${theme.spacing.large};
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing.large};
`;

const SectionTitle = styled.h2`
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.medium};
`;

const Text = styled.p`
  color: ${theme.colors.text};
  line-height: 1.6;
  margin-bottom: ${theme.spacing.medium};
`;

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      
      <Section>
        <SectionTitle>1. No Data Collection</SectionTitle>
        <Text>
          Ufi IPTV is committed to protecting your privacy. Our application does not collect, store, or process any personal data or user information. We believe in complete transparency and privacy for our users.
        </Text>
      </Section>

      <Section>
        <SectionTitle>2. How Our App Works</SectionTitle>
        <Text>
          Ufi IPTV operates as a client-side application only. All content is streamed directly to your device without any intermediate storage or data collection. Your viewing preferences and settings are stored locally on your device only.
        </Text>
      </Section>

      <Section>
        <SectionTitle>3. Third-Party Services</SectionTitle>
        <Text>
          While Ufi IPTV itself does not collect or store any data, we recommend reviewing the privacy policies of any third-party services or content providers you may access through our application.
        </Text>
      </Section>

      <Section>
        <SectionTitle>4. Your Privacy Rights</SectionTitle>
        <Text>
          Since we do not collect or store any personal data, there is no need for data access, correction, or deletion requests. Your privacy is protected by design.
        </Text>
      </Section>

      <Section>
        <SectionTitle>5. Contact Us</SectionTitle>
        <Text>
          If you have any questions about our privacy practices or this Privacy Policy, please contact us at:
          zeplinlabs@gmail.com
        </Text>
      </Section>
    </Container>
  );
};

export default PrivacyPolicy;